import {AssetTypes, DebtTypes, Frequencies, PersonalAccommodationSituations} from "../../../../../../../../models";
import {Figure} from "../Figure";

export function monthlyPra(mortgage) {
    const {currencyAccounts} = mortgage.accountSummary()

    function rentPayments(applicant) {

        // this doesn't work for 1 app


        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        //isCohabitingRenting = applicant 2 is cohabiting but pays something towards rent
        const isCohabitingRenting = applicant === 2 && mortgage.twoApplicants && mortgage.requirement.cohabiting && mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RENTED && mortgage[applicantN].financial.monthlyAccommodationCosts
        const isApplicantRenting = mortgage[applicantN].personal.accommodationSituation === PersonalAccommodationSituations.RENTED
        const disabled = !isApplicantRenting && !isCohabitingRenting
        const fig = new Figure({
            label: `Rent - ${appFirstName}`,
            disabled,
            namesPath: [`applicant${applicant}`, 'pra', 'rent'],
            provable: false,
            float: false,
        })

        if (!fig.disabled) {
            fig.setAlert('Rent not confirmed')
            fig.setValue(mortgage[applicantN].financial.monthlyAccommodationCosts, `Claimed rent payments`)
        }
        return fig
    }

    function mortgagePayments(applicant) {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const isCohabitingPayingMortgage = applicant === 2 && mortgage.twoApplicants && mortgage.requirement.cohabiting && mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.OWNED && mortgage[applicantN].financial.monthlyAccommodationCosts
        const isMortgaging = mortgage.mortgageType === 'REFINANCE' || mortgage[applicantN].personal.accommodationSituation === PersonalAccommodationSituations.OWNED
        const disabled = !isMortgaging && !isCohabitingPayingMortgage
        const fig = new Figure({
            label: `Mortgage Payments - ${appFirstName}`,
            disabled,
            namesPath: [`applicant${applicant}`, 'pra', 'mortgage'],
            provable: false,
            float: false,
        })
        if (!fig.disabled) {
            fig.setAlert('Mortgage not confirmed')
            fig.setValue(mortgage[applicantN].financial.monthlyAccommodationCosts, `Claimed mortgage payments`)
        }
        return fig
    }

    function boardingPayments(applicant) {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const isCohabitingBoarding = applicant === 2 && mortgage.twoApplicants && mortgage.requirement.cohabiting && mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES && mortgage.applicant1.financial.contributeToRelatives && mortgage[applicantN].financial.monthlyAccommodationCosts
        const isApplicantBoarding = mortgage[applicantN].personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES && mortgage[applicantN].financial.contributeToRelatives
        const disabled = !isApplicantBoarding && !isCohabitingBoarding
        const fig = new Figure({
            label: `Boarding - ${appFirstName}`,
            disabled,
            namesPath: [applicantN, 'pra', 'boarding'],
            provable: false,
            float: false,
        })
        if (!fig.disabled) {
            fig.setAlert('Boarding payments not confirmed')
            fig.setValue(mortgage[applicantN].financial.monthlyAccommodationCosts, `Claimed boarding payments`)
        }
        return fig
    }

    function clearingLoans(applicant) {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;

        const uploadSections = mortgage.uploadSections.filter(it => it.data?.debtType === DebtTypes.LOAN && it.applicant === applicant && it.data?.clearedBeforeMortgage);

        const fig = new Figure({
            label: `Clearing Loans - ${appFirstName}`,
            disabled: uploadSections.length === 0,
            namesPath: [applicantN, 'pra', 'clearingLoans'],
            provable: true,
            float: false,
        })
        let sumLoanPayments = 0
        uploadSections.forEach(section => {
            // get the most recent upload for this loan
            const mostRecentUpload = section.verifiableUploads.reduce((latest, current) => {
                return (!latest || (current.values.endDate > latest.values.endDate)) ? current : latest;
            }, null)
            if (mostRecentUpload?.values?.monthlyPayment) {
                fig.addMethod({
                    description: section.data.lender + ' Upload',
                    amount: mostRecentUpload.values.monthlyPayment,
                    claimed: section.data?.monthlyPayment,
                    uploadID: mostRecentUpload.id,
                    operator: '+',
                })
                sumLoanPayments += mostRecentUpload.values.monthlyPayment;
            } else {
                // if no monthly payment in most recent upload, look for any upload with monthly payment

                const mostRecentUploadWithPayment = section.verifiableUploads.reduce((latest, current) => {
                    if (current.values.monthlyPayment) {
                        return (!latest || (current.values.endDate > latest.values.endDate)) ? current : latest;
                    }
                    return latest;
                }, null)
                if (mostRecentUploadWithPayment) {
                    fig.addMethod({
                        description: section.data.lender + ' Upload',
                        amount: mostRecentUploadWithPayment.values.monthlyPayment,
                        claimed: section.data?.monthlyPayment,
                        uploadID: mostRecentUploadWithPayment.id,
                        operator: '+',
                        warning: 'Most recent upload is missing monthly payment value'
                    })
                    sumLoanPayments += mostRecentUploadWithPayment.values.monthlyPayment;
                } else {
                    fig.addMethod({
                        description: section.data.lender + ' Claimed',
                        amount: section.data?.monthlyPayment,
                        claimed: section.data?.monthlyPayment,
                        uploadID: null,
                        operator: '+',
                        warning: 'No uploads with monthly payment value'
                    })
                    sumLoanPayments += section.data?.monthlyPayment || 0;
                }
            }

        })

        fig.setValue(sumLoanPayments, 'Total clearing payments')
        return fig
    }

    function otherPra(applicant) {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const methods = []
        const total = mortgage[applicantN].employmentIncome.reduce((acc, cur) => {
            if (cur?.usingAvcAmount) {
                const avcAmt = Math.round(cur.usingAvcAmount / 12)
                methods.push({description: `${appFirstName} AVC ${cur.usingAvcAmount} ÷ 12 = ${avcAmt}`, amount: avcAmt, claimed: null, uploadID: null, operator: '+'})
                acc += avcAmt
            }
            // if (cur?.usingBikAmount) {
            //     const bikAmt = Math.round(cur.usingBikAmount / 12)
            //     methods.push({description: `${appFirstName} BIK ${cur.usingBikAmount} ÷ 12 = ${bikAmt}`, amount: bikAmt, claimed: null, uploadID: null, operator: '+'})
            //     acc += bikAmt
            // }
            if (cur?.usingShareSaveAmount) {
                const shareSaveAmt = Math.round(cur.usingShareSaveAmount / 12)
                methods.push({description: `${appFirstName} Share Save ${cur.usingShareSaveAmount} ÷ 12 = ${shareSaveAmt}`, amount: shareSaveAmt, claimed: null, uploadID: null, operator: '+'})
                acc += shareSaveAmt
            }
            return acc
        },0)

        const fig = new Figure({
            label: `Other PRA - ${appFirstName}`,
            disabled: total===0,
            namesPath: [applicantN, 'pra', 'other'],
            provable: false,
            float: false,
        })

        if (total === 0){
            fig.setAlert('No proven other pra items')
            fig.setValue(0, `No other PRA items`)
        }
        else{
            fig.setValue(total, `Proven other PRA items`)
            methods.forEach(method => fig.addMethod(method))
        }
        return fig
    }

    function savings(applicant) { // savings rate!!
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        //const euros = currencyAccounts['€'].accounts
        const euros = Object.values(currencyAccounts).flatMap(account => account.accounts )
        const applicantEuros = euros?.filter(e => e.applicant === applicant) || []
        const applicantEurosToUse = applicantEuros.filter(e => e.includeInCalculations)
        const avg = Math.round(applicantEurosToUse.reduce((acc, cur) => {
            acc += (cur.convertedAverageSavings ?? cur.averageSavings ?? 0)
            return acc
        }, 0))


        let claimed = 0
        // new way
        if (mortgage[applicantN].financial.hasSavings || mortgage[applicantN].financial.hasCurrentAccountSavings) {
            claimed = mortgage[applicantN].financial.monthlySavings || 0
        }
        const filter = asset => {
            if (asset.assetType === AssetTypes.SAVING) {
                if ([
                    Frequencies.MONTHLY,
                    Frequencies.WEEKLY,
                    Frequencies.FORTNIGHTLY
                ].includes(asset.increasesFrequency)) {
                    return true
                }
            }
            return false
        }
        const savingRateMethods = []
        if (claimed === 0) {
            const oldSavings = mortgage[applicantN].assets.filter(filter)
            let savingRateErrors = []
            claimed = oldSavings.reduce((acc, asset) => {
                if (!asset.increasesFrequency) {
                    savingRateErrors.push(`Missing saving frequency for ${asset.institution}`)
                }
                if (!asset.increases) {
                    savingRateErrors.push(`Missing saving increase amount for ${asset.institution}`)
                }
                if (!savingRateErrors.length) {
                    let num
                    switch (asset.increasesFrequency) {
                        case Frequencies.MONTHLY:
                            num = asset.increases || 0
                            acc += num
                            savingRateMethods.push({
                                description: `${asset.institution} ${asset.increases}/month`,
                                amount: num,
                                claimed: num,
                                uploadID: null,
                                operator: '+',
                            })
                            break
                        case Frequencies.FORTNIGHTLY:
                            num = Number((asset.increases * 26 / 12).toFixed(2))
                            acc += num
                            savingRateMethods.push({
                                description: `${asset.institution} ${asset.increases}/fortnight`,
                                amount: num,
                                claimed: num,
                                uploadID: null,
                                operator: '+',
                            })
                            break
                        default:
                            num = Number((asset.increases * 52 / 12).toFixed(2))
                            acc += num
                            savingRateMethods.push({
                                description: `${asset.institution} ${asset.increases}/week`,
                                amount: num,
                                claimed: num,
                                uploadID: null,
                                operator: '+',
                            })

                    }
                }

                return acc
            }, 0)
        }
        claimed = Math.round(claimed)

        const fig = new Figure({
            label: `Savings - ${appFirstName}`,
            disabled: claimed === 0 && avg === 0,
            namesPath: [`applicant${applicant}`, 'pra', 'savings'],
            provable: true,
            float: false,
        })

        // are we using claimed or verified?
        let haveVerified = applicantEurosToUse.length


        if (haveVerified) {
            if (!applicantEurosToUse.length) {

                fig.setAlert('Nothing included in calculations - using claimed savings')
                savingRateMethods.forEach(method => fig.addMethod(method))
                fig.setValue(claimed, 'Claimed savings rate')
                return fig
            } else {
                fig.setValue(avg, 'Verified average savings from statements')
                applicantEurosToUse.forEach(acc => {
                    fig.addMethod({
                        description: `Statement - ${acc.institution}: ${acc.convertedAverageSavings ? `(${acc.currency}${acc.averageSavings} @ fx${acc?.convertRate})`:``} `,
                        amount: acc.convertedAverageSavings ?? acc.averageSavings ?? 0,
                        claimed: null,
                        uploadID: null,
                        operator: '+',
                    })
                })
                return fig
            }
        } else {
            savingRateMethods.forEach(method => fig.addMethod(method))
            fig.setAlert('No verified savings available')
            fig.setValue(claimed, 'Claimed savings rate')
            return fig
        }
    }

    const pra = [rentPayments(1)]
    if (mortgage.twoApplicants) {
        pra.push(rentPayments(2))
    }
    pra.push(mortgagePayments(1))
    if (mortgage.twoApplicants) {
        pra.push(mortgagePayments(2))
    }
    pra.push(boardingPayments(1))
    if (mortgage.twoApplicants) {
        pra.push(boardingPayments(2))
    }
    pra.push(clearingLoans(1))
    if (mortgage.twoApplicants) {
        pra.push(clearingLoans(2))
    }
    pra.push(savings(1))
    if (mortgage.twoApplicants) {
        pra.push(savings(2))
    }
    pra.push(otherPra(1))
    if (mortgage.twoApplicants) {
        pra.push(otherPra(2))
    }
    return pra

}